import React from 'react';
import PropTypes from 'prop-types';

export function InputErrorComponent({ error }:any) {
  return (
    <>
      {error && (
        <div className="flex items-center mt-2 text-xs text-red-600">
          {error}
        </div>
      )}
    </>
  );
}

InputErrorComponent.propTypes = {
  error: PropTypes.string,
};